import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { setCloningModal, setPendingRemoval, selectPendingRemoval } from '../../../reducers/cloning_steps'
import useSessionSaver from '../../../hooks/useSessionSaver'

const ConfirmRoundRemovalModal = () => {
  const dispatch = useDispatch()
  const pendingRemoval = useSelector(selectPendingRemoval)
  const { removeDateFromMassDates } = useSessionSaver()

  const closeModal = () => {
    dispatch(setPendingRemoval(null))
    dispatch(setCloningModal(null))
  }

  const handleConfirm = () => {
    if (pendingRemoval?.leagueId && pendingRemoval?.dateKey) {
      removeDateFromMassDates(pendingRemoval.leagueId, pendingRemoval.dateKey)
    }
    closeModal()
  }

  const handleCancel = closeModal

  return (
    <BaseCloningModal
      title={window.I18n.t('clone_leagues_sessions.modals.confirm_round_removal.title')}
      content={<span>{window.I18n.t('clone_leagues_sessions.modals.confirm_round_removal.content')}</span>}
      leftButton={<GlgButton
        className={'cls-steps-modal__left_button'}
        text={window.I18n.t('clone_leagues_sessions.modals.confirm_round_removal.cancel')}
        onClick={handleCancel}
      />}
      rightButton={<GlgButton
        className={'cls-steps-modal__right_button'}
        text={window.I18n.t('clone_leagues_sessions.modals.confirm_round_removal.confirm')}
        onClick={handleConfirm}
      />}
    />
  )
}

export default ConfirmRoundRemovalModal
